import { useQuery } from '@tanstack/react-query'
import { Section, Cell, Caption } from '@telegram-apps/telegram-ui'
import { CheckCircle2, Briefcase, Home } from 'lucide-react'

import { api } from '../../lib/api'
import type { Task } from '../../lib/types'
import PageHeader from '../../components/PageHeader'
import { SkeletonList } from '../../components/Skeleton'
import EmptyState from '../../components/EmptyState'
import { formatDate } from '../../lib/format'

/** Выполненные поручения для исполнителя (Анастасии или Владимира). */
export default function AssigneeDone() {
  const { data, isLoading } = useQuery<Task[]>({
    queryKey: ['tasks', 'done', 'mine'],
    queryFn: () => api.get<Task[]>('/tasks?status=done'),
  })

  return (
    <>
      <PageHeader title="Выполненные" caption={data ? `Всего: ${data.length}` : undefined} />

      {isLoading ? (
        <SkeletonList count={5} />
      ) : !data || data.length === 0 ? (
        <EmptyState icon={CheckCircle2} title="Пусто" description="Здесь будут все Ваши завершённые задачи." />
      ) : (
        <Section>
          {data.map((t) => (
            <Cell
              key={t.id}
              before={<CheckCircle2 size={20} strokeWidth={2} color="var(--success)" />}
              subtitle={
                <Caption style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                  {t.category === 'work' ? <Briefcase size={12} /> : <Home size={12} />}
                  · выполнено {t.done_at ? formatDate(t.done_at) : ''}
                </Caption>
              }
              multiline
            >
              {t.title}
            </Cell>
          ))}
        </Section>
      )}
    </>
  )
}
